import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { distinctUntilChanged, map, Observable, startWith } from 'rxjs';

@Pipe({
  name: 'findFirstErrorKeyFromControl',
  standalone: true,
})
export class FindFirstErrorKeyFromControlPipe implements PipeTransform {
  transform(
    control: AbstractControl,
    errorNameAndErrorKeyPairs: Record<string, string>,
    prefix = '',
  ): Observable<string | null> {
    const errorKeys = Object.keys(errorNameAndErrorKeyPairs);

    return control.statusChanges.pipe(
      startWith(control.status),
      map(() => {
        for (const key of errorKeys) {
          if (control.hasError(key)) {
            return prefix + errorNameAndErrorKeyPairs[key];
          }
        }

        return null;
      }),
      distinctUntilChanged(),
    );
  }
}
